export default {
    nav: {
        index: "Home",
        theme: "Theme parks",
        restaurant: "Food and beverages",
        activity: "Themed events",
        performance: "Wonderful interpretations",
        service: "Visitor services",
        online: "Online bookings"
    },
    language: {
        Chinese: 'Chinese',
        English: "English",
        korea: 'Korea',
        Japanese: 'Japanese'
    },
    service: {
        work_time: "Business hours",
        traffic: "Traffic Guide",
        map_title: "Park map",
        problems_title: "Frequently asked questions",
        notice_title: "Instructions to Visitors",
        complaints_title: "Complaint suggestions ",
        video_title: "Video area",
        discount_title: "Special offers",
        tour_server: 'Tour guide service ',
        security_check:'Anti-counterfeiting Check'
    },
    theme: [
        "Chuanlord Scream Island",
        "Fairy Tale Animal Kingdom",
        "Chuanlord Resort",
        "Military Theme Park",
        "Farmhouse Theme Park",
        "Underwater World Theme Park",
        "Wetland Theme Park"],
    footerNav: [
        'Recruitment',
        'News Center',
        'Contact Us',
        'About Chuanlord Group',
        'Company Profile',
        'Internet links',
        'Inspirational sharing'],
    theme_bg_tit: "Theme background",
    cart: "Enter shopping cart",
    name: "Chuanlord Tourism Leisure Expo Park",
    search_title: "Full Text Search",
    service_tel: " Customer Service Hotline", //客服电话热线
    address: "Address", //地址
    address_content: "Chuanlord Tourism Leisure Expo Park, Sanzhou Jianshe East Road, Lunjiao, Shunde, Foshan City, Guangdong Province",
    activity: ['Fun activities', 'Special Offers', 'Rob Ticket Activity'],
    base_info: 'Basic Information',//基本信息,
    traffic_type: [
        "self-driving route",
        "Bus line",
        "Light rail line",
        'Airport line'
    ],
    resume: "resume",//尾页 招贤纳士 个人履历
    shop_cart: "shopping cart",//购物车名词
    traffic_system: "Long deer tourism leisure expo park traffic inquiry system",
    map_download: "Map download",
    order: 'Order information confirmation',
    pay_info: "Pay success",
    upload: "Upload annual card information",
    personal: "My Center",
    card_bag: "My card bag",
    login: "Login",
    register: "Register",
    join: 'I apply for',
    my_order: "My order",
    tourist_map: "Tourist map",
    work_type: [
        'Social recruitment',
        'Internship recruitment',
        'Management trainee recruitment',
        'Part-time recruitment'
    ],
    enter_key: "Please enter the position keyword",// 招贤纳士的占位符
    time_notice: "In order to get more information about the performance time of more activities, you can call the information hotline.",
    consult_tel: "hotline",
    online_type: [
        "Ticket reservation",
        "Hotel reservation",
        "Chuanlord annual card",
        "Specials"
    ],
    placeholder_verity: "Please enter the verification code",
    get_verity: "Get Verification Code",
    account: "Account login",
    without_code: "Avoid close login",
    placeholder_code: "Please enter your account number",
    placeholder_psd: "Please enter a 6-20 digit password",
    placeholder_img_verity: "Please enter graphic verification code",
    placeholder_repeat_psd: "Please enter your password again",
    submit: "Submit",
    send_code: "Send verification code",
    please_login: "Please login",
    experience: "Experience",
    department: "Department",
    education: "Education",
    recruitment: "Recruitment type",
    recruitment_number: "Recruiting numbers",
    release_time: "Release time",
    work_address: "Workplace ",
    employ: "Apply for",
    month: "month",
    newsNav: [
        "Company News",
        "Park Announcement"
    ],
    view_count: "Views",
    recent: "The recent news",
    education_bg: "Educational Background",
    detail_address: "Detailed address",
    save: "Save",
    submit_applications: "Submit applications",
    certificate: "certificate",
    tip: "Please complete and save the required fields before proceeding to the next step",
    placeholder_c: "Please enter what you are searching for",
    contact_tel: "Contact number",
    switchboard: " switchboard",
    complaints_hotline: " complaints phone",
    Medical_phone: "Medical phone",
    house_phone: "Fire phone",
    all_address: "Chuanlord Tourism Leisure Expo Park, Sanzhou Jianshe East Road, Lunjiao, and Shunde, Foshan City, Guangdong Province (Shunde Lunjiao Sanzhou and Panyu Shawan Junction)",
    company: "Guangdong Chuanlord Tourism & Leisure Expo Park Co., Ltd.",
    hotline: "consultation phone",
    hotline_tip: "(24-hour hotline)",
    placeholder_location: "Please enter the starting position",
    notice_tip: "Please observe the above regulations. Thank you for your cooperation! Wish you a pleasant journey",
    complaints_type: "Complaints type",
    select: "Please select",
    phone: "Phone",
    placeholder_suggestion: "Please write your opinion",
    sure_submit: "Confirm to submit",
    activity_time: "Activity Time",
    still_time: "There's still time to go",
    start_time: "Activity start time is",
    grab_num: "Has seized number",
    all: "all",
    piece: "pieces",
    select_time: "Please select the date of departure",
    select_grab: "Please select the number of tickets",
    activity_detail: "Programme Description",
    past: "finished",
    progress: "underway",
    to: "to",
    show_time: "Show time",
    placeholder_key: "Search by keyword",
    job_title: "Job title",
    depart: "Department",
    personal_data: "Personal information",
    head_portrait: "Head portrait",
    compellation: "The name",
    sex: "gender",
    sex_men: "male",
    sex_women: "female",
    birthday: "Date of birth",
    contact_way: "contact",
    email: "Email address",
    address_now: "In the address",
    height: "height",
    weight: "weight",
    academic: "The highest record of formal schooling",
    learning: "Learn form",
    academic_lists:[
        "Primary school",
        "Junior high school",
        "Technical secondary school",
        "High school",
        "college",
        "Undergraduate course",
        "A graduate student",
        "Dr."
    ],
    learning_lists:[
        "Full-time unified recruitment",
        "Adult the university entrance exam",
        "The remote education",
        "Take an examination of",
        "National development university"
    ],
    job_intention: "objective",
    expected_salary: "Expect a salary",
    arrival_time: "The work time",
    next: "The next step",
    placeholder_name: "Please enter name",
    placeholder_birth: "Please enter date of birth",
    placeholder_mail: "Please enter your email address",
    placeholder_way: "Please enter contact information",
    placeholder_address: "Please enter address",
    placeholder_height: "Please enter height",
    placeholder_weight: "Please enter your weight",
    placeholder_salary: "Please enter expected monthly salary before tax",
    placeholder_arrival: "Please select the available time",
    upload_img: "Upload pictures",
    upload_detail: "*Upload a close-up bust of parents and children",
    idCard: "ID card",
    placeholder_real_name: "Please enter your real name",
    placeholder_idCard: "Please fill in your id card number",
    placeholder_phone: "Please fill in your mobile phone number",
    error_msg: "Network error, please contact administrator",
    discount: "discount coupon",
    date: "Date",
    score: "points",
    total_score: "The total number of points",
    unused_score: "Available integral",
    used_score: "Using the integral",
    detail_info: "More Detail",
    integration: "credits",
    order_num: "OrderID:",
    use_hour: "Hours of use:",
    contact_person: "Contact information:",
    all_sum: "Total:",
    personal_info: "Personal Data",
    certificate_card: "ID Number",
    age: "age",
    mail: "mailbox",
    submit_data: "Submit personal information",
    placeholder_age: "Please enter age",
    placeholder_card: "Please enter id number",
    placeholder_tel: "Please enter your mobile phone number",
    join_grab : "Tickets to rob",
    crazy: "Crazy",
    grabbing: "Rob tickets in" ,
    notYet: "No yet",
    start: "start",
    IC_case:'Guangdong business and commerce industry filed',
    G_case :"Guangdong ICP filed",
    home_axios: {
        main: [
            {
                "name": "Ticket reservation",
                "mobile_value": "http://www.chuanloo.com/m/#/market?dex=0",
                "child": [
                    {
                        "name": "Motor ticket",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=230",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=230",
                    },
                    {

                        "name": "Motorized tickets",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=166",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=166",
                    },
                    {
                        "name": "Fairy tale zoo",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=167",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=167",
                    },
                    {

                        "name": "Happy family package",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/ticket-detail.html?goods_id=190",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=190",
                    }
                ]
            },
            {
                "name": "Hotel reservation",
                "mobile_value": "http://www.chuanloo.com/m/#/market?dex=1",
                "child": [
                    {
                        "name": "Characteristic rural house",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=202",
                    },
                    {
                        "name": "Special carriage house",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=195",
                    },
                    {

                        "name": "Watertown style room",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=196",
                    },
                    {

                        "name": "Duplex family suite",
                        "value": "http://www.chuanloo.com/web/tpl/onlineOrder/hotelOrder.html",
                        "mobile_value": "http://www.chuanloo.com/m/#/ticketDetail?goods_id=198",
                    }
                ]
            },
            {
                "name": "Chuanlord annual card",
                "mobile_value": "http://www.chuanloo.com/m/#/market?dex=2",
                "child": [
                    {
                        "name": "A single year",
                        "mobile_value": "http://#",
                    },
                    {
                        "name": "Couple years card",
                        "mobile_value": "http://#",
                    },
                    {
                        "name": "Year of the family card",
                        "mobile_value": "http://#",
                    },
                    {
                        "name": "Parent-child year",
                        "mobile_value": "http://#",
                    }
                ]
            },
            {
                "name": "Specials",
                "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                "child": [
                    {

                        "name": "Sweet package",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    },
                    {
                        "name": "Submarine restaurant",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    },
                    {
                        "name": "八角亭餐厅",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    },
                    {
                        "name": "恐龙谷餐厅",
                        "mobile_value": "http://www.chuanloo.com/m/#/market/?dex=3",
                    }
                ]
            }
        ],
        minor: [
            {name: "Business hours"},
            {name: "Traffic Guide"},
            {name: "Park map"},
            {name: "Discount information"}
        ]
    }
}
